module.exports = __webpack_public_path__ + "img/t-26422-057.afce0dbf.jpg";